'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".PickerBlock-module_pickerBlock__ttvFx{display:flex;flex-wrap:wrap;gap:10px;grid-auto-flow:column;justify-content:center}.PickerBlock-module_pickerBlockItem__OpMoU{border:0;border-radius:5px;cursor:pointer;padding:16px 12px}";
var styles = {"pickerBlock":"PickerBlock-module_pickerBlock__ttvFx","pickerBlockItem":"PickerBlock-module_pickerBlockItem__OpMoU"};
styleInject["default"](css_248z, '08627ca0-fb45-44e6-9ae7-e64dde5a6c16');

exports["default"] = styles;
